import { render, staticRenderFns } from "./MyProduct.vue?vue&type=template&id=01850681&"
import script from "./MyProduct.vue?vue&type=script&lang=ts&"
export * from "./MyProduct.vue?vue&type=script&lang=ts&"
import style0 from "./MyProduct.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports